import { motion } from "framer-motion";
import { Rocket, ArrowUpRight } from "lucide-react";

export default function CTA() {
    return (
        <section
            id="cta"
            data-testid="cta-section"
            className="relative py-24 md:py-32 bg-white overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    className="relative rounded-[2.5rem] overflow-hidden bg-gradient-to-br from-ae-ink via-[#1e1e22] to-ae-ink p-8 md:p-16 lg:p-20"
                >
                    {/* Decorative orange glow */}
                    <div className="absolute -top-32 -right-32 h-[420px] w-[420px] rounded-full bg-ae-orange/35 blur-[120px]" />
                    <div className="absolute -bottom-40 -left-32 h-[360px] w-[360px] rounded-full bg-ae-orange-light/25 blur-[100px]" />
                    <div
                        className="absolute inset-0 opacity-[0.06]"
                        style={{
                            backgroundImage:
                                "linear-gradient(rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.4) 1px, transparent 1px)",
                            backgroundSize: "48px 48px",
                        }}
                    />

                    <div className="relative grid lg:grid-cols-12 gap-10 items-center">
                        <div className="lg:col-span-8">
                            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-ae-orange/15 text-ae-orange-light border border-ae-orange/30 text-xs font-bold uppercase tracking-[0.22em]">
                                <Rocket className="h-4 w-4" />
                                Ready When You Are
                            </div>
                            <h2
                                data-testid="cta-headline"
                                className="mt-5 font-display font-extrabold text-4xl md:text-6xl lg:text-7xl text-white tracking-tight leading-[1.02]"
                            >
                                Ready to{" "}
                                <span className="ae-text-gradient">Amplify Everything?</span>
                            </h2>
                            <p
                                data-testid="cta-service-line"
                                className="mt-6 text-base md:text-lg text-white/70 max-w-2xl"
                            >
                                Strategy. Creative. AI. Advertising. Software. Interactive
                                activations.
                            </p>
                        </div>

                        <div className="lg:col-span-4 flex flex-col gap-4">
                            <a
                                href="#contact"
                                data-testid="cta-start-project"
                                className="group inline-flex items-center justify-between gap-3 bg-ae-orange text-white rounded-2xl px-6 py-5 text-base md:text-lg font-semibold hover:bg-ae-orange-light shadow-ae-lift hover:shadow-ae-glow transition-all"
                            >
                                Start a Project
                                <span className="h-9 w-9 rounded-full bg-white/15 flex items-center justify-center group-hover:rotate-45 transition-transform">
                                    <ArrowUpRight className="h-4 w-4" />
                                </span>
                            </a>
                            <a
                                href="#contact"
                                data-testid="cta-contact"
                                className="group inline-flex items-center justify-between gap-3 bg-white/5 text-white border border-white/15 rounded-2xl px-6 py-5 text-base md:text-lg font-semibold hover:bg-white hover:text-ae-ink transition-all"
                            >
                                Contact AE
                                <span className="h-9 w-9 rounded-full bg-white/10 group-hover:bg-ae-orange/20 flex items-center justify-center transition-colors">
                                    <ArrowUpRight className="h-4 w-4" />
                                </span>
                            </a>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
